import { gql } from '@apollo/client';

export const GET_DEPOSIT_INSURANCE_UPLOAD_TASKS = gql`
  query DepositInsuranceUploadTasks($offset: Int!, $limit: Int!) {
    depositInsuranceUploadTasks(offset: $offset, limit: $limit) {
      total
      items {
        id
        sourceFileName
        submitterName
        createdAt
        periodStart
        periodEnd
        rowCount
        totalAmountCents
        depositAmountCents
        insuranceAmountCents
        successCount
        failCount
        status
        failureReason
        hasResultFile
      }
    }
  }
`;

export const GET_DEPOSIT_INSURANCE_RESULT_FILE_URL = gql`
  query DepositInsuranceResultFileUrl($taskId: Long!) {
    depositInsuranceResultFileUrl(taskId: $taskId)
  }
`;

export const GET_DEPOSIT_INSURANCE_SOURCE_FILE_URL = gql`
  query DepositInsuranceSourceFileUrl($taskId: Long!) {
    depositInsuranceSourceFileUrl(taskId: $taskId)
  }
`;
